import { supabase } from './supabase';
import type { BreathingRatio } from './api';

export type NewBreathingRatio = Omit<
  BreathingRatio,
  'id' | 'created_at' | 'updated_at'
>;

const TABLE = 'breathing_ratio';

export async function listBreathingRatios(
  includeInactive = false
): Promise<BreathingRatio[]> {
  let query = supabase
    .from(TABLE)
    .select('*')
    .order('name', { ascending: true });

  if (!includeInactive) {
    query = query.eq('active', true);
  }

  const { data, error } = await query;

  if (error) throw error;
  return (data as BreathingRatio[]) || [];
}

export async function createBreathingRatio(
  input: NewBreathingRatio
): Promise<BreathingRatio> {
  const payload = {
    name: input.name,
    ratio: input.ratio,
    description: input.description,
    active: input.active,
  };

  const { data, error } = await supabase
    .from(TABLE)
    .insert(payload)
    .select('*')
    .single();

  if (error) throw error;
  return data as BreathingRatio;
}

export async function updateBreathingRatio(
  id: string,
  input: NewBreathingRatio
): Promise<BreathingRatio> {
  const payload = {
    name: input.name,
    ratio: input.ratio,
    description: input.description,
    active: input.active,
  };

  const { data, error } = await supabase
    .from(TABLE)
    .update(payload)
    .eq('id', id)
    .select('*')
    .single();

  if (error) throw error;
  return data as BreathingRatio;
}

export async function deleteBreathingRatio(id: string): Promise<void> {
  const { error } = await supabase.from(TABLE).delete().eq('id', id);

  if (error) throw error;
}
